export default defineAppConfig({
  ui: {
    toast: {
      slots: {
        root: [
          'relative group overflow-hidden bg-default shadow-lg rounded-lg ring ring-default p-4 flex gap-2.5 focus:outline-none mb-4 sm:mb-0',
        ],
      },
    },
    colors: {
      primary: 'tomate',
      secondary: 'bleuet',
      tertiary: 'sauge',
      neutral: 'poivre',
      fourth: 'glace',
      error: 'red',
      success: 'emerald',
      info: 'sky',
      warning: 'yellow',
    },
    button: {
      slots: {
        base: [
          'rounded-full font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75',
          'transition-colors',
        ],
      },
      defaultVariants: {
        size: 'lg',
      },
    },
    pagination: {
      slots: {
        item: 'rounded-xl',
      },
    },
    defaults: {
      UButton: {
        size: 'lg',
      },
    },
    card: {
      slots: {
        root: 'rounded-lg overflow-hidden',
        header: 'p-4 sm:px-6',
        body: 'p-4 sm:p-6',
        footer: 'p-4 sm:px-6',
      },
      variants: {
        variant: {
          outline: {
            root: 'ring-0 divide-y divide-default',
          },
        },
      },
    },
    modal: {
      slots: {
        title: 'uppercase text-base font-semibold',
        content: '!max-h-[calc(100dvh-var(--safe-top)-var(--safe-bottom)-2rem)] sm:!max-h-[calc(100dvh-var(--safe-top)-var(--safe-bottom)-4rem)]',
      },
    },
    slideover: {
      slots: {
        title: 'uppercase text-base font-semibold',
        content: '!top-[var(--safe-top)] !bottom-[var(--safe-bottom)]',
      },
    },
    input: {

      variants: {
        size: {
          md: { base: 'px-2.5 py-1.5 text-base gap-1.5', leading: 'ps-2.5', trailing: 'pe-2.5', leadingIcon: 'size-5', leadingAvatarSize: '2xs', trailingIcon: 'size-5',
          },
          lg: { base: 'px-3 py-2 text-base gap-2', leading: 'ps-3', trailing: 'pe-3', leadingIcon: 'size-5', leadingAvatarSize: '2xs', trailingIcon: 'size-5' },
        },
      },
    },
    textarea: {

      variants: {
        size: {
          md: { base: 'text-base',
          },
          lg: { base: 'text-base' },
        },
      },
    },
    dashboardPanel: {
      slots: {
        body: 'p-0 sm:p-0',
      },
    },
  },

})
